<div class="titulo-receber-table-cliente">
    <table class="table table-striped table-hover table-bordered" id="tituloReceberTableCliente">
        <thead>
            <tr>
                <th class="col-options"></th>
                <th class="col-pessoa">Cliente</th>
                <th class="col-representante">Representante</th>
                <th class="col-valor text-right">Valor</th>
                <th class="col-valor-pago text-right">Valor Pago</th>
                <th class="col-valor-juros text-right">Juros</th>
                <th class="col-valor-saldo text-right">Saldo</th>
            </tr>
        </thead>
        <tfoot>
            <tr>
                <td class="col-options">
                    
                </td>
                <td class="col-pessoa">
                    {{(total?.quantidadeClientes ? total?.quantidadeClientes : 0) | decimalFormat: 1:0:0}} cliente(s)
                </td>                
                <td class="col-representante"></td>                                            
                <td class="col-valor text-right">
                    {{(total?.valorTotal ? total?.valorTotal : 0) | currencyFormat: 1:2:2}}
                </td>
                <td class="col-valor-pago text-right">
                    {{(total?.valorTotalPago ? total?.valorTotalPago : 0) | currencyFormat: 1:2:2}}
                </td>
                <td class="col-valor-juros text-right"></td>
                <td class="col-valor-saldo text-right">
                    {{(total?.valorTotalSaldo ? total?.valorTotalSaldo : 0) | currencyFormat: 1:2:2}}
                </td>                                          
            </tr>
        </tfoot>
    </table>         
</div>